function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 4,
  fill: "#EEF5FF"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M20.0001 13C13.6931 13 10.6331 18.683 10.0901 19.808C10.0607 19.8677 10.0454 19.9334 10.0454 20C10.0454 20.0666 10.0607 20.1323 10.0901 20.192C10.6321 21.317 13.6921 27 20.0001 27C26.3081 27 29.3671 21.317 29.9101 20.192C29.9395 20.1323 29.9547 20.0666 29.9547 20C29.9547 19.9334 29.9395 19.8677 29.9101 19.808C29.3681 18.683 26.3081 13 20.0001 13Z",
  stroke: "#365DE6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M20 23C21.6569 23 23 21.6569 23 20C23 18.3431 21.6569 17 20 17C18.3431 17 17 18.3431 17 20C17 21.6569 18.3431 23 20 23Z",
  stroke: "#365DE6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgColoredOpenEye = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgColoredOpenEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/colored-open-eye.e7d70678.svg";
export { ForwardRef as ReactComponent };